// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
export const getCredentials = state => state.contactReducer.credentials;
export const getMessage = state => state.contactReducer.message;
export const getData = state => state.contactReducer.data;
